// Module
var code = "<bringoz-button theme=\"secondary\" type=\"outline\" (on-click)=\"$ctrl.onClick({ event: $event })\" permission permission-only=\"'drivers.create'\"> <bringoz-icon icon-name=\"plus\" class-size=\"lg\"></bringoz-icon> </bringoz-button> <md-tooltip> <span translate>Create Driver</span> </md-tooltip> ";
// Exports
export default code;